const $ = require('jquery');

/**
 *@description expands/collapses 'Legal Terms' section in the newsletter
 */
exports.init = function () {
    $('body').on('click', '.legal-terms-show-more', function (event) {
        const $showMoreButton = $(this);
        let $showMoreContent = $showMoreButton.siblings('.legal-terms-show-more-content');
        let $showLessButton = $showMoreContent.find('.legal-terms-show-less');

        if ($showMoreContent.length === 0 && $showLessButton.length === 0) {
            const wrapper = $showMoreButton.closest('.legal-terms-wrapper');

            $showLessButton = wrapper.find('.legal-terms-show-less');
            $showMoreContent = wrapper.find('.legal-terms-show-more-content');
        }

        event.preventDefault();
        $showMoreButton.hide();
        $showMoreContent.slideDown(function () {
            if (
                !$showMoreContent.parents('.ocd-flyin').length &&
                $showMoreButton.closest('.ui-dialog').length === 0 &&
                !$showMoreContent.parents('.subscribe-1774-form').length
            ) {
                $('html, body').animate(
                    {
                        scrollTop: $showMoreContent.parent().offset().top - 150
                    },
                    300
                );
            }
        });

        $showLessButton.on('click', function (event2) {
            event2.preventDefault();
            $showLessButton.off();
            $showMoreContent.slideUp(function () {
                $showMoreButton.show();

                if (
                    !$showMoreButton.parents('.ocd-flyin').length &&
                    $showMoreButton.closest('.ui-dialog').length === 0 &&
                    !$showMoreContent.parents('.subscribe-1774-form').length
                ) {
                    $('html, body').animate(
                        {
                            scrollTop: $showMoreButton.parent().offset().top - 150
                        },
                        300
                    );
                }
            });
        });

        $showLessButton.on('keydown', function (event2) {
            if (event2.key === 'Enter' || event2.key === ' ') {
                event2.preventDefault();
                this.click();
            }
        });
    });

    $('body').on('keydown', '.legal-terms-show-more', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.click();
        }
    });
};
